import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEN from './locales/en/translation.json';
import translationES from './locales/es/translation.json';
import { getStoredLanguage } from './helpers/language/language.helper';

// Browser-language auto-detection is handled manually in app init, setting auto-detect in the
// i18n config caused it to ignore the feature flag
i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    // Guarded, and narrowed to a language we support: this read runs at module load,
    // where a browser blocking storage would otherwise throw before the app starts.
    lng: getStoredLanguage() ?? 'en',
    supportedLngs: ['en', 'es'],
    fallbackLng: 'en',
    defaultNS: 'translation',
    react: { useSuspense: false },
    interpolation: { escapeValue: false },
    resources: {
      en: {
        translation: translationEN,
      },
      es: {
        translation: translationES,
      },
    },
  });
